import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface RangeInputProps {
  label: string;
  name: string;
  value: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  min: number;
  max: number;
  step: number;
  icon: LucideIcon;
  unit: string;
  markers: string[];
}

export function RangeInput({
  label,
  name,
  value,
  onChange,
  min,
  max,
  step,
  icon: Icon,
  unit,
  markers
}: RangeInputProps) {
  const labelClasses = "block text-base font-medium text-gray-700 mb-2";
  const sliderClasses = "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500";

  return (
    <div>
      <label htmlFor={name} className={labelClasses}>
        {label}
      </label>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Icon className="h-5 w-5 text-blue-500" />
          <span className="text-lg font-medium text-gray-900">
            {value}{unit}
          </span>
        </div>
        <input
          type="range"
          name={name}
          id={name}
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={onChange}
          className={sliderClasses}
        />
        <div className="flex justify-between text-sm text-gray-500">
          {markers.map((marker, index) => (
            <span key={index}>{marker}</span>
          ))}
        </div>
      </div>
    </div>
  );
}